import React from 'react';

const TabButton = ({ label, active, onClick, icon, count }) => {
  return (
    <button
      onClick={onClick}
      className={`px-2 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4 text-xs sm:text-sm md:text-base font-medium transition-all duration-200 flex items-center ${
        active
          ? 'text-indigo-700 border-b-2 border-indigo-600 bg-indigo-50'
          : 'text-gray-600 hover:bg-gray-50'
      }`}
    >
      {icon && (
        <span className={`w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 rounded-full ${
          active ? 'bg-indigo-100' : 'bg-gray-100'
        } flex items-center justify-center ml-1 sm:ml-1.5 md:ml-2`}>
          {icon({ 
            className: `h-3 w-3 sm:h-4 sm:w-4 md:h-5 md:w-5 ${
              active ? 'text-indigo-600' : 'text-gray-500'
            }`
          })}
        </span>
      )}
      <span className="truncate">{label}</span>
      {count > 0 && (
        <span className="mr-1 sm:mr-1.5 md:mr-2 bg-indigo-600 text-white text-2xs sm:text-xs rounded-full px-1.5 sm:px-2 py-0.5 sm:py-1 inline-flex items-center justify-center min-w-[16px] sm:min-w-[20px] h-4 sm:h-5">
          {count}
        </span>
      )}
    </button>
  );
};

export default TabButton;